import React from 'react'

const IconoTexto = (props) => {
    const { colorTitulo, colorSubTitulo, tituloTamano, subTituloTamano, titulo = 'Los Mejores Precios', subTitulo = 'Lorem Ipsum es simplemente el texto de relleno.', nombre = 'fa-solid fa-check', nombreTamanoIcon, colorIcono } = props?.styles

    return (
        <div className='iconoTexto'>
            <i className={nombre} style={{ color: colorIcono, fontSize: `${nombreTamanoIcon}px` }} />
            <div className='iconoTexto-container'>
                <h5 style={{ fontSize: `${tituloTamano}px`, color: colorTitulo }}>{titulo}</h5>
                <p style={{
                    color: colorSubTitulo,
                    fontSize: `${subTituloTamano}px`
                }}>{subTitulo}</p>
            </div>
        </div>
    )
}

export default IconoTexto